import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { mutationFnPOST } from "api/tanStackQuery/helpers";
import { upcomingEventsQueryKey } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/EventsOverviewButtonAndModal";
import { InfrastructureRequest } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/requestSchema";
import { InfrastructureEventCreatedResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/utils";
import { useCountryCodeForDropsRole } from "shared/hooks/useCountryCodeForDropsRole";

export const usePostInfrastructureEvent = (uuid?: string) => {
  const queryClient = useQueryClient();
  const countryCode = useCountryCodeForDropsRole();

  return useMutation({
    mutationFn: (body: InfrastructureRequest) =>
      mutationFnPOST<InfrastructureEventCreatedResponse, InfrastructureRequest>(
        `${getBackendUrl()}/infrastructure-event${uuid ? `/${uuid}/change` : ""}`,
        body,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: upcomingEventsQueryKey(countryCode),
      });
    },
  });
};
